/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const MessageResponse = zod
	.object({
		data: zod.string().describe('Response message')
	})
	.describe('Response with a message');

export type MessageResponse = zod.input<typeof MessageResponse>;
export type MessageResponseOutput = zod.output<typeof MessageResponse>;
